/**
 * @file pannel filter by start point
 */

import React, { Component } from 'react';
import Icon from 'antd/lib/icon';
import Button from 'antd/lib/button';
import { DragSource } from 'react-dnd';
const div = React.createFactory('div');
const icon = React.createFactory(Icon);
const button = React.createFactory(Button);

class DragIcon extends Component {
    render() {
        const {
            connectDragSource
        } = this.props;
        return connectDragSource(
            div(
                {
                    className: 'StartPointFilter__drag-icon'
                },
                icon({
                    type: 'environment',
                    style: {fontSize: '24px'}
                })
            )
        );
    }
}

const dragIcon = React.createFactory(DragSource(
    'FILTER',
    {
        beginDrag() {
            return {};
        }
    },
    (connect) => {
        return {
            connectDragSource: connect.dragSource()
        }
    }
)(DragIcon));

class StartPointFilter extends Component {
    render() {
        const {
            startFilter,
            onFilterResetClick
        } = this.props;
        return div(
            {},
            div(
                {
                    className: 'StartPointFilter__filter-pointer-line',
                },
                dragIcon(),
                div(
                    {
                        className: 'StartPointFilter__tip'
                    },
                    'Drag & drop marker on a map to filter by start point'
                ),
                button(
                    {
                        className: 'StartPointFilter__reset-button',
                        disabled: !startFilter,
                        onClick: onFilterResetClick
                    },
                    'Reset filter'
                )

            ),
        );
    }
}

export default StartPointFilter;



// WEBPACK FOOTER //
// ./src/StartPointFilter.js